import { Injectable } from '@angular/core';

declare const apiBaseDomain: string;
declare const useLocalServer: boolean;
declare const useProxy: boolean;

@Injectable({
  providedIn: 'root'
})
export class ApiUrlService {
  buildApiUrl(tenantId: string): string {
    if (useProxy) {
      if (useLocalServer) {
        return `http://localhost:4300/api/${tenantId}`;
      }
      return `http://localhost:4400/api/${tenantId}`;
    }
    
    return `https://${tenantId}${apiBaseDomain}`;
  }
  
  getApiBaseDomain(): string {
    return apiBaseDomain;
  }

  isUsingLocalServer(): boolean {
    return useLocalServer;
  }
}